export default {"src":"/uk/_next/static/media/icon-passport.cbaf3b76.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};